import { render } from "./regions.vue?vue&type=template&id=67769276&ts=true"
import script from "./regions.vue?vue&type=script&lang=ts"
export * from "./regions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__